import template from "./pCasemanProjectConfig.html";

export function pCasemanProjectConfigDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanProjectConfigController,
    controllerAs: 'pCasemanProjectConfig',
    bindToController: true
  };

  return directive;
}

class pCasemanProjectConfigController {
  constructor($scope, $location, $interval, Auth, Caseman, Notes, Sort, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Sort = Sort;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.state = "loading";
    this.changesWereMade = false;
    this.mappers = [];
    this.allMappers = [];
    this.activeMappers = [];
    this.selectedTeamMapper = "placeholder";
    this.showOnlyActive = true;

    this.headers = [
      {name: "CASEMAN.CLIENT", class: null},
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        this.selectedTeam = this.user;

        //Notes...
        const timeout = this.$interval(() => { this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        this.Caseman.getCountryCasemanProjects().then(
          (success) => {
            this.projects = success.data.sort(this.Sort.abcBy("name"));
            this.Caseman.getTeams().then(
              (success) => {
                this.state = "loaded";
                this.teams = success.data.sort(this.Sort.abcBy("name"));
                this.selectedTeam = this.teams[0];
                this.getMappers(this.selectedTeam);
              },
              (error) => {
                this.state = "error";
                this.Notes.postNote({type: "error", error: error});
              }
            );
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  getMappers(selected) {
    this.state = "loading";
    this.changesWereMade = false;
    this.showOnlyActive = true;

    this.Caseman.getIncomeMappers(selected.id).then(
      (success) => {
        this.selectedTeamMapper = success.data.casemanTeamMapper;
        this.allMappers = success.data.clientMappings.map(m => {
          return {
            ...m,
            id: m.client.id,
            name: m.client.name,
            isActive: m.client.isActive,
            projects: m.projects
            .filter((v, i, a) => a.findIndex(t => (t.casemanProjectId === v.casemanProjectId)) === i) // remove duplicates
            .map((mp) => {
              const project = this.projects.find((x) => x.id == mp.casemanProjectId);
              return {
                ...mp,
                name: (project && project.name) || mp.casemanProjectId
              };
            })
          };
        }).sort(this.Sort.abcBy("name"));

        this.activeMappers = this.allMappers.filter(m => m.isActive);
        this.mappers = this.activeMappers;
        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  addProjectToClient(mapperToAddSelection, select) {
    this.changesWereMade = true;
    this.mappers = this.mappers.map((mapper) => {
      if(mapperToAddSelection.id == mapper.id && !mapper.projects.find((p) => p.id == select.id)) {
        return {
          ...mapper,
          projects: [
            ...mapper.projects,
            {
              ...select,
              casemanProjectId: select.id,
              source: "TeamClientProjectMapper"
            }
          ]
        };
      } else {
        return mapper;
      }
    });
  }
  removeProjectFromClient(mapperToRemoveFrom, project) {
    this.changesWereMade = true;
    this.mappers = this.mappers.map((mapper) => {
      if(mapperToRemoveFrom.id == mapper.id) {
        return {
          ...mapper,
          projects: mapper.projects.filter((p) => p.casemanProjectId != project.casemanProjectId)
        };
      } else {
        return mapper;
      }
    });
  }

  saveChanges() {
    this.state = "loading";

    const mappersToPut = this.mappers.map((clientMapper) => {
      const mappers = clientMapper.projects.map((mp) => {
        return {
          casemanProjectId: mp.casemanProjectId,
          clientId: clientMapper.client.id,
          source: mp.source
        };
      }).filter((x) => x.source == 'TeamClientProjectMapper');
      return mappers;
    }).flat();
    this.Caseman.setIncomeMappers(this.selectedTeam.id, mappersToPut).then(() => {
      this.state = "loaded";
      this.changesWereMade = false;
    }).catch((error) => {
      this.state = "loaded";
      this.Notes.postNote({type: "error", error: error});
    });
  }

  toggleActive() {
    if (this.showOnlyActive) {
      this.mappers = this.activeMappers;
    } else {
      this.mappers = this.allMappers;
    }
  }
}
